/**
 * Swiper 10.2.0
 * @url : https://swiperjs.com/api/
 *
 */
// import Swiper JS
// core version + navigation, freemode, scrollbar & keyboard modules:
import Swiper from 'swiper';
import { Navigation, Keyboard, FreeMode, Scrollbar } from 'swiper/modules';

const servicesSlider = Array.from(document.getElementsByClassName('js-swiper-services'));

if (servicesSlider.length) {
  for (const swiper of servicesSlider){
    // Swiper instance
    const swiperInstance = new Swiper(swiper, {
      modules: [Navigation, Keyboard, FreeMode, Scrollbar],
      grabCursor: true,
      slidesPerView: 'auto',
      speed: 700,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboard: true,
      init: false,
      freeMode: true,
      scrollbar: {
        draggable: true,
        el: '.swiper-scrollbar',
        hide: false,
      },
    })

    // Init only if there is 2 or more slides
    const nbSlides = Array.from(swiper.getElementsByClassName('swiper-slide'));

    if (nbSlides.length > 1) {
      swiperInstance.init();
    }
  }
}

